<template>
    <div class="test-comment-textarea-container">
        <quill-editor
            class="test-comment-textarea" :class="{active: content.length, focus: isFocus, 'is-edit': editComment}"
            ref="myTextEditor"
            :disabled="!store.userCanComment"
            :value="content"
            :options="editorOption"
            @change="onEditorChange"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
        />
        <div v-if="content.length" class="test-comment-textarea-btn">
            <button class="btn btn-small btn-outline" @click="cancelComment">
                Відмінити
            </button>
            <button class="btn btn-small" @click="addComment" v-if="store.userCanComment && !messageIsTooLong">
                {{ editComment ? 'Зберегти' : 'Додати'}}
            </button>
        </div>
        <div v-if="!store.userCanComment" class="form-error">Вам заборонено залишати коментарі</div>
        <div v-if="messageIsTooLong" class="form-error">Текст в полі коментар повинен мати довжину не більшу за 1000 символів.</div>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import quillEmoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'
// import theme style
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {tourniquetStore} from "../../../store/store";


export default {
    name: 'TestCommentEditor',
    title: 'Theme: snow',
    setup() {
        const store = tourniquetStore();
        return {store};
    },
    props: ['comment', 'editComment', 'error'],
    components: {
        quillEditor
    },
    data() {
        return {
            editorOption: {
                placeholder: 'Залишити коментар',
                modules: {
                    "emoji-toolbar": true,
                    "emoji-shortname": true,
                    toolbar: [
                        ['bold', 'italic', 'underline'],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        ['link', 'emoji'],
                        ['clean']
                    ],
                }
            },
            content: this.comment || "",
            isFocus: false,
            messageIsTooLong: false
        }
    },
    mounted() {
        if (this.editComment) {
            this.onEditorFocus()
        }
    },
    methods: {
        cancelComment() {
            this.$emit('cancel');
            this.content = this.comment || ""
        },
        addComment() {
            this.$emit('addcomment', this.content);
            if (!this.error) {
                this.content = ""
            }
        },
        onEditorChange(value) {
            this.content = value.html;
            if (value.text.length > 1000) {
                this.messageIsTooLong = true
            } else {
                this.messageIsTooLong = false;
            }
        },
        onEditorBlur() {
            this.isFocus = false
        },
        onEditorFocus() {
            this.isFocus = true
        },
    },
    computed: {
        editor() {
            return this.$refs.myTextEditor.quill
        },
    },
}
</script>

<style lang="scss">
@import "../../../../../sass/front/helpers";
.ql-container.ql-snow,
.ql-toolbar.ql-snow {
    border: 0;
}
.ql-editor.ql-blank::before {
    font-style: normal;
    color: $text-second;
    font-weight: 300;
    font-size: 1.4rem;
}
.test-comment-text, .ql-container {
    font-size: 1.4rem;
    font-family: 'Ukraine';

    .ap {
        text-indent: 0;
        line-height: 20px;
        font-size: 14px;
    }
}

@include responsive-below($xs) {
    .ql-toolbar.ql-snow .ql-formats {
        margin-right: 5px;
    }
    .ql-toolbar.ql-snow {
        padding: 4px;
    }
}
@include responsive-below($xxs) {
    .ql-toolbar.ql-snow .ql-formats {
        margin-right: 4px;
    }
    .test-comment.is-reply .ql-snow.ql-toolbar button {
        padding: 3px;
    }
    .test-comment.is-reply .ql-toolbar.ql-snow .ql-formats {
        margin-right: 2px;
    }
}
</style>
